module.exports = __webpack_public_path__ + "static/media/user-calling.5ad94149.svg";